import { EMAIL_REGEX } from '../../constants'

export function execute(submission, isUnderwriter, type) {
  const requiredFields = []

  if (submission.occupancy == 'true') {
    if (!submission.occupancyDescription) {
      requiredFields.push({
        questionId: '11.4',
        text: 'Is there a separate ingress/egress for construction workers? ',
        inputType: 'dropdown-single',
        name: 'occupancyDescription',
      })
    }
  }
  const addins =
    submission.additionalInsured == 'true' &&
      submission.additionalInsuredArray &&
      submission.additionalInsuredArray.length > 0
      ? submission.additionalInsuredArray.filter((ins) => {
        return (
          Object.keys(ins).includes('additionalInsuredRole') ||
          Object.keys(ins).includes('secondAdditionalInsuredRole') ||
          Object.keys(ins).includes('thirdAdditionalInsuredRole') ||
          (Object.keys(ins).includes('additionalInsuredForms') &&
            ins.additionalInsuredForms.includes('0413')) ||
          (Object.keys(ins).includes('secondAdditionalInsuredForms') &&
            ins.secondAdditionalInsuredForms.includes('0413')) ||
          (Object.keys(ins).includes('thirdAdditionalInsuredForms') &&
            ins.thirdAdditionalInsuredForms.includes('0413'))
        )
      })
      : []

  if (addins.length > 0) {
    requiredFields.push({
      questionId: '5_supplemental1',
      text: 'Additional Insured Details',
      inputType: 'text',
      name: 'updateAdditionalInsured',
    })
  }

  if (submission.additionalInsured == 'true') {
    if (!submission.additionalInsuredName) {
      requiredFields.push({
        questionId: '5_supplemental1',
        text: 'Additional Insured Name',
        inputType: 'text',
        name: 'additionalInsuredName',
      })
    }
    if (
      !submission.additionalInsuredRelationship ||
      submission.additionalInsuredRelationship === 'placeholder'
    ) {
      requiredFields.push({
        questionId: '5_supplemental2',
        text: 'Additional Insured Relationship',
        inputType: 'text',
        name: 'additionalInsuredRelationship',
      })
    }
    if (
      submission.additionalInsuredRelationship === 'Lender/Mortgagee' &&
      !submission.banksMortgagees
    ) {
      requiredFields.push({
        questionId: '7_supplemental1',
        text: 'Specify lender for first additional insured',
        inputType: 'text',
        name: 'banksMortgagees',
      })
    }
    if (
      submission.additionalInsuredRelationship === 'Other' &&
      !submission.additionalInsuredRelationshipOther
    ) {
      requiredFields.push({
        questionId: '18_supplemental2a',
        text: 'Specify relationship for first additional insured',
        inputType: 'text',
        name: 'additionalInsuredRelationshipOther',
      })
    }
    if (!submission.additionalInsuredOther) {
      requiredFields.push({
        questionId: '5_supplemental4',
        text: 'Additional insured other',
        inputType: 'radio',
        name: 'additionalInsuredOther',
      })
    }
  }

  if (submission.additionalInsuredOther == 'true') {
    if (!submission.secondAdditionalInsuredName) {
      requiredFields.push({
        questionId: '17_supplemental1',
        text: 'Second Additional Insured Name',
        inputType: 'text',
        name: 'secondAdditionalInsuredName',
      })
    }

    if (
      !submission.secondAdditionalInsuredRelationship ||
      submission.secondAdditionalInsuredRelationship === 'placeholder'
    ) {
      requiredFields.push({
        questionId: '17_supplemental2',
        text: 'Second Additional Insured Relationship',
        inputType: 'text',
        name: 'secondAdditionalInsuredRelationship',
      })
    }
    if (
      submission.secondAdditionalInsuredRelationship === 'Lender/Mortgagee' &&
      !submission.secondBanksMortgagees
    ) {
      requiredFields.push({
        questionId: '7_a_supplemental2',
        text: 'Specify lender for second additional insured',
        inputType: 'text',
        name: 'secondBanksMortgagees',
      })
    }

    if (
      submission.secondAdditionalInsuredRelationship === 'Other' &&
      !submission.secondAdditionalInsuredRelationshipOther
    ) {
      requiredFields.push({
        questionId: '14_supplemental2a',
        text: 'Specify relationship for second additional insured',
        inputType: 'text',
        name: 'secondAdditionalInsuredRelationshipOther',
      })
    }
    if (!submission.secondAdditionalInsuredOther) {
      requiredFields.push({
        questionId: '17_supplemental4',
        text: 'Second additional insured other',
        inputType: 'radio',
        name: 'secondAdditionalInsuredOther',
      })
    }
  }
  if (submission.secondAdditionalInsuredOther == 'true') {
    if (!submission.thirdAdditionalInsuredName) {
      requiredFields.push({
        questionId: '19_supplemental1',
        text: 'Third Additional Insured Name',
        inputType: 'text',
        name: 'thirdAdditionalInsuredName',
      })
    }

    if (
      !submission.thirdAdditionalInsuredRelationship ||
      submission.thirdAdditionalInsuredRelationship === 'placeholder'
    ) {
      requiredFields.push({
        questionId: '19_supplemental2',
        text: 'Third Additional Insured Relationship',
        inputType: 'text',
        name: 'thirdAdditionalInsuredRelationship',
      })
    }
    if (
      submission.thirdAdditionalInsuredRelationship === 'Lender/Mortgagee' &&
      !submission.thirdBanksMortgagees
    ) {
      requiredFields.push({
        questionId: '7_a_supplemental3',
        text: 'Specify lender for third additional insured',
        inputType: 'text',
        name: 'thirdBanksMortgagees',
      })
    }

    if (
      submission.thirdAdditionalInsuredRelationship === 'Other' &&
      !submission.thirdAdditionalInsuredRelationshipOther
    ) {
      requiredFields.push({
        questionId: '21_supplemental2a',
        text: 'Specify relationship for third additional insured',
        inputType: 'text',
        name: 'thirdAdditionalInsuredRelationshipOther',
      })
    }
  }

  const startDate = new Date(submission.anticipatedStartDate).getTime()
  const finishDate = new Date(submission.anticipatedFinishDate).getTime()

  if (startDate > finishDate) {
    requiredFields.push({
      questionId: '100',
      text: 'Anticipated Finish Date cannot be before Anticipated Start Date',
      inputType: 'text',
      name: 'finishDateCannotBeforeStartDate',
    })
  }

  const today = new Date().setUTCHours(0, 0, 0, 0)
  if (finishDate < today) {
    requiredFields.push({
      questionId: '100',
      text: 'Anticipated Finish Date must not be before today’s date',
      inputType: 'text',
      name: 'finishDateCannotBeforeTodaysDate',
    })
  }
  let _90backday = new Date()
  _90backday = new Date().setDate(_90backday.getDate() - 91)
  if (startDate < today) {
    if (!isUnderwriter) {
      requiredFields.push({
        questionId: '101',
        text: 'Start date must not be before today’s date',
        inputType: 'text',
        name: 'startDateCannotBeforeTodaysDate',
      })
    } else if (startDate < _90backday) {
      requiredFields.push({
        questionId: '101',
        text: 'Start date must not be lesser than 90days from now',
        inputType: 'text',
        name: 'startDateCannotBefore90Days',
      })
    }
  }

  let _90day = new Date()
  _90day = new Date().setDate(_90day.getDate() + 90)
  if (startDate > _90day) {
    requiredFields.push({
      questionId: '101',
      text: 'Start date must not be greater than 90days from now',
      inputType: 'text',
      name: 'startDateCannotAfter90Days',
    })
  }

  if (
    submission.AuditorInfo &&
    typeof submission.AuditorInfo.auditorEmail === 'string' &&
    submission.AuditorInfo.auditorEmail.trim().length > 0
  ) {
    const regexEmail = new RegExp(EMAIL_REGEX)

    if (!regexEmail.test(submission.AuditorInfo.auditorEmail.trim())) {
      requiredFields.push({
        questionId: '67bb',
        text: 'Audit Contact Information email is invalid.',
        inputType: 'text',
        name: 'auditorEmailIsInvalid',
      })
    }
  }
  if (submission.type === 'ocp' && !submission.limitsRequested) {
    requiredFields.push({
      questionId: '101',
      text: 'GL limits are being requested for this OCP',
      inputType: 'text',
      name: 'limitsRequested',
    })
  }
  if (submission.type === 'ocp' && submission.limitsRequested === '66') {
    requiredFields.push({
      questionId: '1017',
      text: 'Limits are required',
      inputType: 'text',
      name: 'limitsRequested',
    })
  }
  if (submission.type === 'oi' && !submission.excessLimitAmount) {
    requiredFields.push({
      questionId: '1019',
      text: 'Excess limits are being requested for this OI',
      inputType: 'text',
      name: 'excessLimitAmount',
    })
  }
  if (submission.verticalExpansion && !submission.isHorizontalExpansion) {
    requiredFields.push({
      questionId: '1020',
      text: 'Does the project include any horizontal expansion?',
      inputType: 'text',
      name: 'isHorizontalExpansion',
    })
  }
  if (submission.verticalExpansion && !submission.isVerticalExpansion) {
    requiredFields.push({
      questionId: '1021',
      text: 'Does the project include any vertical expansion?',
      inputType: 'text',
      name: 'isVerticalExpansion',
    })
  }
  if (submission.exteriorDemo === 'true') {
    if (!submission.demolitionDetailsCost) {
      requiredFields.push({
        questionId: '997.1',
        text: 'Total Demolition Cost',
        inputType: 'number',
        name: 'demolitionDetailsCost',
      })
    }
    if (!submission.demolitionDetailsGCOwner) {
      requiredFields.push({
        questionId: '997.2',
        text: 'Who is hiring the demolition contractor, the General Contractor, or the Owner',
        inputType: 'radio',
        name: 'demolitionDetailsGCOwner',
      })
    }
    if (!submission.demolitionDetailsInterior) {
      requiredFields.push({
        questionId: '997.3',
        text: 'Is the demo work being performed interior only?',
        inputType: 'radio',
        name: 'demolitionDetailsInterior',
      })
    }
  }
  if (submission.constructionSite === 'Remodel/Renovation') {
    if (!submission.structuralWork) {
      requiredFields.push({
        questionId: '24_supplemental1',
        text: 'Will there be any structural work performed?',
        inputType: 'radio',
        name: 'structuralWork',
      })
    }
  }
  if (
    submission.projectRequirements &&
    submission.projectRequirements.includes('homeBuilding')
  ) {
    requiredFields.push({
      questionId: 15,
      text: 'Does the project involve work related to any of the following',
      inputType: 'checkbox',
      name: 'projectRequirements',
    })
  }

  if (submission.servicingSeveralLocations === 'true') {
    if (!submission.otherSiteAddress1) {
      requiredFields.push({
        questionId: '17_supplementalB',
        text: 'Additional Site 1 Address',
        inputType: 'text',
        name: 'otherSiteAddress1',
      })
      if (!submission.otherSiteCity1) {
        requiredFields.push({
          questionId: '17_supplementalC',
          text: 'Additional Site 1 City',
          inputType: 'text',
          name: 'otherSiteCity1',
        })
      }
      if (!submission.otherSiteState1) {
        requiredFields.push({
          questionId: '17_supplementalD',
          text: 'Additional Site 1 State',
          inputType: 'dropdown-single',
          name: 'otherSiteState1',
        })
      }
      if (!submission.otherSiteZipcode1) {
        requiredFields.push({
          questionId: '17_supplementalE',
          text: 'Additional Site 1 Zipcode',
          inputType: 'text',
          name: 'otherSiteZipcode1',
        })
      }
      if (!submission.otherSitesAdditional1) {
        requiredFields.push({
          questionId: '17_supplementalF',
          text: 'Are there any additional Sites?',
          inputType: 'radio',
          name: 'otherSitesAdditional1',
        })
      }
    }
    if (submission.otherSitesAdditional1 === 'true') {
      if (!submission.otherSiteAddress2) {
        requiredFields.push({
          questionId: '18_supplementalB',
          text: 'Additional Site 2 Address',
          inputType: 'text',
          name: 'otherSiteAddress2',
        })
      }
      if (!submission.otherSiteCity2) {
        requiredFields.push({
          questionId: '18_supplementalC',
          text: 'Additional Site 2 City',
          inputType: 'text',
          name: 'otherSiteCity2',
        })
      }
      if (!submission.otherSiteState2) {
        requiredFields.push({
          questionId: '18_supplementalD',
          text: 'Additional Site 2 State',
          inputType: 'dropdown-single',
          name: 'otherSiteState2',
        })
      }
      if (!submission.otherSiteZipcode2) {
        requiredFields.push({
          questionId: '18_supplementalE',
          text: 'Additional Site 2 Zipcode',
          inputType: 'text',
          name: 'otherSiteZipcode2',
        })
      }
      if (!submission.otherSitesAdditional2) {
        requiredFields.push({
          questionId: '18_supplementalF',
          text: 'Are there any additional Sites?',
          inputType: 'radio',
          name: 'otherSitesAdditional2',
        })
      }
    }
    if (submission.otherSitesAdditional2 === 'true') {
      if (!submission.otherSiteAddress3) {
        requiredFields.push({
          questionId: '19_supplementalB',
          text: 'Additional Site 3 Address',
          inputType: 'text',
          name: 'otherSiteAddress3',
        })
      }
      if (!submission.otherSiteCity3) {
        requiredFields.push({
          questionId: '19_supplementalC',
          text: 'Additional Site 3 City',
          inputType: 'text',
          name: 'otherSiteCity3',
        })
      }
      if (!submission.otherSiteState3) {
        requiredFields.push({
          questionId: '19_supplementalD',
          text: 'Additional Site 3 State',
          inputType: 'dropdown-single',
          name: 'otherSiteState3',
        })
      }
      if (!submission.otherSiteZipcode3) {
        requiredFields.push({
          questionId: '19_supplementalE',
          text: 'Additional Site 3 Zipcode',
          inputType: 'text',
          name: 'otherSiteZipcode3',
        })
      }
      if (!submission.otherSitesAdditional3) {
        requiredFields.push({
          questionId: '19_supplementalF',
          text: 'Are there any additional Sites?',
          inputType: 'radio',
          name: 'otherSitesAdditional3',
        })
      }
    }
    if (submission.otherSitesAdditional3 === 'true') {
      if (!submission.otherSiteAddress4) {
        requiredFields.push({
          questionId: '20_supplementalB',
          text: 'Additional Site 4 Address',
          inputType: 'text',
          name: 'otherSiteAddress4',
        })
      }
      if (!submission.otherSiteCity4) {
        requiredFields.push({
          questionId: '20_supplementalC',
          text: 'Additional Site 4 City',
          inputType: 'text',
          name: 'otherSiteCity4',
        })
      }
      if (!submission.otherSiteState4) {
        requiredFields.push({
          questionId: '20_supplementalD',
          text: 'Additional Site 4 State',
          inputType: 'dropdown-single',
          name: 'otherSiteState4',
        })
      }
      if (!submission.otherSiteZipcode4) {
        requiredFields.push({
          questionId: '20_supplementalE',
          text: 'Additional Site 4 Zipcode',
          inputType: 'text',
          name: 'otherSiteZipcode4',
        })
      }
      if (!submission.otherSitesAdditional4) {
        requiredFields.push({
          questionId: '20_supplementalF',
          text: 'Are there any additional Sites?',
          inputType: 'radio',
          name: 'otherSitesAdditional4',
        })
      }
    }
    if (submission.otherSitesAdditional4 === 'true') {
      if (!submission.otherSiteAddress5) {
        requiredFields.push({
          questionId: '21_supplementalB',
          text: 'Additional Site 5 Address',
          inputType: 'text',
          name: 'otherSiteAddress5',
        })
      }
      if (!submission.otherSiteCity5) {
        requiredFields.push({
          questionId: '21_supplementalC',
          text: 'Additional Site 5 City',
          inputType: 'text',
          name: 'otherSiteCity5',
        })
      }
      if (!submission.otherSiteState5) {
        requiredFields.push({
          questionId: '21_supplementalD',
          text: 'Additional Site 5 State',
          inputType: 'dropdown-single',
          name: 'otherSiteState5',
        })
      }
      if (!submission.otherSiteZipcode5) {
        requiredFields.push({
          questionId: '21_supplementalE',
          text: 'Additional Site 5 Zipcode',
          inputType: 'text',
          name: 'otherSiteZipcode5',
        })
      }
    }
  }

  let cdRatedBasePremium
  if (!!submission.ratings) {
    cdRatedBasePremium = submission.ratings.options.baseCoverageOption[
      submission.coverages.gl.base
    ]
      ? submission.ratings.options.baseCoverageOption[submission.coverages.gl.base]
      : submission.ratings.options.basePremium
  }
  if (
    submission.manuallySetPricing === 'true' &&
    !!cdRatedBasePremium &&
    submission.ratings[submission.type].basePremium != cdRatedBasePremium &&
    !submission.onCreditNotes &&
    isUnderwriter
  ) {
    requiredFields.push({
      questionId: '101',
      text: 'Underwriter notes is mandatory when credit/debit is applied ',
      inputType: 'text',
      name: 'onCreditNotes',
    })
  }

  if (
    submission.manuallySetPricing === 'true' &&
    isUnderwriter &&
    !submission.onGCLimitNotes
  ) {
    let initialValues
    let updatedValues
    try {
      initialValues =
        submission.type === 'oi'
          ? submission.ratings.oi.systemLimits.u658
          : submission.ratings.ocp.systemLimits.ocp008a
      updatedValues =
        submission.type === 'oi'
          ? submission.ratings.oi.limits.u658
          : submission.ratings.ocp.limits.ocp008a
    } catch (err) {
      console.log({ errorMessage: err.message })
    }
    let flag = false
    if (initialValues !== undefined && updatedValues !== undefined) {
      flag = Object.entries(initialValues).reduce((acc, curr) => {
        let value = updatedValues[curr[0]]
        if (Number.isNaN(Number(value))) {
          value = +value.replace(/\$|,/gi, '')
        }
        return acc || value !== curr[1]
      }, false)
    }
    if (flag) {
      requiredFields.push({
        questionId: '101',
        text: 'Underwriter notes is mandatory when GC Required Limits are changed.',
        inputType: 'text',
        name: 'onGCLimitNotes',
      })
    }
  }

  const limit = submission.excessLimitAmount
  if (!isUnderwriter && limit && !Number.isNaN(limit) && Number(limit) > 10000000) {
    requiredFields.push({
      questionId: '101',
      text: 'Excess limit amount',
      inputType: 'text',
      name: 'excessLimitBroker',
    })
  }

  return requiredFields
}
